/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />
/// <reference path="../adpIntegration/adpIntegration.context.ts" />

module Meevo.Plugins.AdpRunIntegration {
    "use strict";
    
    export class AdpRunIntegrationContext extends Meevo.Plugins.AdpIntegration.AdpIntegrationContext {

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            busyService: Meevo.Components.Busy.IBusyService,
            $rootScope: ng.IRootScopeService,
            protected $translate: angular.translate.ITranslateService,
            contextParams: Meevo.ContextParamsService
        ) {

            super(appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                securityChecker,
                trackingService,
                busyService,
                $rootScope,
                $translate,
                contextParams);
        }

        Init(): void {
            this.baseEndpoint = this.appSettings.API_ENDPOINTS.adpRunIntegration;
            this.sectionTemplatePath = "app/plugins/adpRunIntegration/sectionViews/";
            this.buildCrudSecurityKeysBase(this.securityKeys.INTEGRATION_ADPINTEGRATION_TAB_MAIN);
        }
        
        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_ADPINTEGRATION_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.mainSection = new RunMainSection(0,
                    "SECTION_MAIN",
                    "main.html",
                    true,
                    false,
                    this.baseEndpoint,
                    "",
                    this.loggingService,
                    this.dataService,
                    Model.NounEnum.AdpIntegrationMain,
                    this.identityService,
                    this.modalService,
                    this.busyService,
                    this.securityKeys.INTEGRATION_ADPINTEGRATION_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ);
                this.sections.push(this.mainSection);
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_ADPINTEGRATION_TAB_EMPLOYEES + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.employeeSection = 
                    new RunEmployeeSection(1,
                        "HEADER_EMPLOYEE",
                        "employee.html",
                        false,
                        false,
                        this.baseEndpoint,
                        "mapemployees",
                        this.loggingService,
                        this.dataService,
                        Model.NounEnum.AdpIntegrationEmployees,
                        this.identityService,
                        this.modalService,
                        this.busyService,
                        this.rootScope,
                        this.appSettings,
                        this.securityKeys.INTEGRATION_ADPINTEGRATION_TAB_EMPLOYEES + Meevo.Components.Common.SecurityParts.KEY_PART_READ);
                this.sections.push(this.employeeSection);
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_ADPINTEGRATION_TAB_COMMISSION + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.commissionSection = new RunCommissionSection(2,
                    "LABEL_PAY_OPTIONS",
                    "commission.html",
                    false,
                    false,
                    this.baseEndpoint,
                    "mapcommissiontypes",
                    this.loggingService,
                    this.dataService,
                    this.$translate,
                    Model.NounEnum.AdpIntegrationCommission,
                    this.identityService,
                    this.modalService,
                    this.busyService,
                    this.compensationSettingsEndPoint,
                    this.securityKeys.INTEGRATION_ADPINTEGRATION_TAB_COMMISSION + Meevo.Components.Common.SecurityParts.KEY_PART_READ);
                this.sections.push(this.commissionSection);
            }
           
            this.activate();
          
        }  
        public goToMarketplace(): void {
            const adpLinkMarketplace = window['AdpLinkMarketplace'];
            window.open(adpLinkMarketplace, '_blank');
        }

        public goToConsent(): void {
            const adpLinkConsent = window['AdpLinkConsent'];
            window.open(adpLinkConsent, '_blank');
        }

        public goToAdpLogin(): void {
            const adpRunLoginLink = window['AdpRunLoginLink'];
            window.open(adpRunLoginLink, '_blank');
        }
    }
}
